export const API_HOST = (process.env.REACT_APP_API_URL ).replace(/\/$/, "");
export const API_BASE_URL = `${API_HOST}/api`;

// Client-side saved events storage
const SavedEvents = {
  get: () => {
    try {
      const saved = localStorage.getItem('savedEvents');
      return saved ? JSON.parse(saved) : [];
    } catch (error) {
      console.error('Error getting saved events:', error);
      return [];
    }
  },
  save: (events) => {
    try {
      localStorage.setItem('savedEvents', JSON.stringify(events));
      return true;
    } catch (error) {
      console.error('Error saving events:', error);
      return false;
    }
  }
};

const api = {
  // Shared endpoints
  shared: {
    login: `${API_BASE_URL}/shared/login`,
    events: {
      approved: `${API_BASE_URL}/shared/events/approved`,
      available: `${API_BASE_URL}/shared/events/available`,
      topCapacity: `${API_BASE_URL}/shared/events/top-capacity`,
      getById: (id) => `${API_BASE_URL}/shared/events/${id}`,
    },
  },
  
  // Customer endpoints
  customer: {
    ticketPurchases: `${API_BASE_URL}/customer/ticket-purchases`,
    savedEvents: {
      get: () => Promise.resolve(SavedEvents.get()),
      save: (eventId) => {
        const savedEvents = SavedEvents.get();
        if (!savedEvents.includes(eventId)) {
          const updated = [...savedEvents, eventId];
          SavedEvents.save(updated);
          return Promise.resolve(updated);
        }
        return Promise.resolve(savedEvents);
      },
      remove: (eventId) => {
        const savedEvents = SavedEvents.get();
        const updated = savedEvents.filter(id => id !== eventId);
        if (updated.length !== savedEvents.length) {
          SavedEvents.save(updated);
        }
        return Promise.resolve(updated);
      }
    },
  },
  
  // Organizer endpoints
  organizer: {
    events: {
      base: `${API_BASE_URL}/organiser/events`,
      getById: (id) => `${API_BASE_URL}/organiser/events/${id}`,
      create: `${API_BASE_URL}/organiser/events`,
      rehost: (id) => `${API_BASE_URL}/organiser/events/${id}/rehost`,
      attendees: (id) => `${API_BASE_URL}/organiser/events/${id}/attendees`,
    },
    ticketPurchases: {
      getById: (id) => `${API_BASE_URL}/organiser/ticket-purchases/${id}`,
      updateStatus: (id) => `${API_BASE_URL}/organiser/ticket-purchases/${id}/status`,
    },
  },
  
  // Admin endpoints
  admin: {
    events: {
      base: `${API_BASE_URL}/admin/events`,
      getById: (id) => `${API_BASE_URL}/admin/events/${id}`,
      updateStatus: (id) => `${API_BASE_URL}/admin/events/${id}/status`,
      proofOfPayment: (id) => `${API_BASE_URL}/admin/events/${id}/proof-of-payment`,
    },
  },
  
  // Other endpoints
  faculties: `${API_BASE_URL}/faculties`,
};

export default api;
